import React from 'react'

export default Callout => {
  return (
    <div className="blog-page--callout">
      <h3>
        <a
          target="_blank"
          href="http://www.youtube.com/channel/UCZK2TNTp0P9OhNiSYw9rA_A?sub_confirmation=1"
        >
          Subscribe on YouTube
        </a>
      </h3>
      <p>
        We update the channel regularly with the latest client work and special
        event videos.
      </p>
      <a
        target="_blank"
        href="http://www.youtube.com/channel/UCZK2TNTp0P9OhNiSYw9rA_A?sub_confirmation=1"
      >
        <i className="fa fa-youtube-play"></i>
      </a>
    </div>
  )
}
